<!--
    Intro: ekran początkowy
-->

    <i18n>
        {
        "en": {
        "helix": "Helix Collection",
        "start": "START THE {br} CONFIGURATION"
        },
        "fr": {
        "helix": "Collection Helix",
        "start": "DÉMARRER LA {br} CONFIGURATION"
        },
        "pl": {
        "helix": "Kolekcja Helix",
        "start": "START {br} KONFIGURACJI"
        },
        "de": {
        "helix": "Helix Kollektion",
        "start": "KONFIGURATION {br} STARTEN"
        }
        }
    </i18n>

<template>
    <div class="Intro" :style="{ display: computedDiplay }">
        <div class="overlay"></div>
        <p class="helix">{{ $t('helix') }}</p>
        <div class="pivot">
            <img class="logo" src="@/assets/icons/createx-logo.png" />
            <button @click="changeSceneClick('select')">
                <i18n path="start" tag="span">
                    <br slot="br" />
                </i18n>
            </button>
        </div>
        <LocalePanel />
    </div>
</template>

<script>
    import LocalePanel from './LocalePanel.vue';

    export default {
        name: 'Intro',

        props: {
            scene: String
        },
        data() {
            return {
            }
        },
        components: {
            LocalePanel
        },
        mounted: function () {

        },
        computed: {
            computedDiplay: function () {
                return (this.scene.split("_")[0] == 'intro') ? 'block' : 'none';
            }
        },
        methods: {
            changeSceneClick: function (val) {
                this.$root.$emit('changeSceneClick', val)
            }
        }
    };
</script>

<style scoped>
    .Intro {
        position: absolute;
        z-index: 100;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 21px;
        color: #FFF;
        text-align: center;
        background-position: center center;
        background-size: cover;
        background-color: #434D56;
        background-image: url('~@/assets/backgrounds/intro.jpg');
    }

    .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #E0E0E0;
        opacity: .6;
        transition: all 0.5s ease;
    }

    .pivot {
        position: absolute;
        top: 0;
        left: 50%;
        width: 0;
        height: 100%;
        margin: auto;
        text-align: center;
    }

    .logo {
        position: absolute;
        top: 6%;
        left: -90px;
        width: 180px;
        /*background-image: url('~@/assets/icons/creabel-logo.png');*/
    }

    .helix {
        position: relative;
        margin: 280px auto 0;
        font-size: 3rem;
        color: #FFF;
    }

    button {
        position: absolute;
        top: 64%;
        left: -160px;
        border: none;
        border-radius: 8px;
        /*margin-left: -160px;*/
        width: 320px;
        height: 120px;
        display: block;
        cursor: pointer;
        outline: none;
        box-sizing: border-box;
        background: #434D56;
        transition: all 0.5s ease;
    }

        button span {
            position: relative;
            font-size: 28px;
            color: #FFF;
            text-transform: uppercase;
        }
</style>